import React from "react";
import Contactform from "../Contactform";
import Address from "../Address";
import Headcontact from "../Headcontact";

const Contact = () => {
  return (
    <>
      <Headcontact />
      <Address />
      <Contactform />
    </>
  );
};

export default Contact;
